import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  DashboardOutlined,
  UserOutlined,
  CalendarOutlined,
  ShoppingCartOutlined,
  WalletOutlined,
  MenuOutlined
} from '@ant-design/icons'
import { Badge } from 'antd'

/**
 * Mobile Bottom Navigation Component
 * Only visible on mobile devices
 */
const MobileNavigation = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 })
  const navigate = useNavigate()
  const location = useLocation()

  if (!isMobile) return null

  const navItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Home',
      path: '/dashboard'
    },
    {
      key: '/leads',
      icon: <UserOutlined />,
      label: 'Leads',
      path: '/leads'
    },
    {
      key: '/bookings',
      icon: <CalendarOutlined />,
      label: 'Bookings',
      path: '/bookings'
    },
    {
      key: '/inventory',
      icon: <ShoppingCartOutlined />,
      label: 'Inventory',
      path: '/inventory'
    },
    {
      key: '/finance',
      icon: <WalletOutlined />,
      label: 'Finance',
      path: '/finance'
    }
  ]

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/')
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#fff',
        borderTop: '1px solid #e8e8e8',
        padding: '8px 0',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        zIndex: 1000,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        height: '60px'
      }}
    >
      {navItems.map((item) => (
        <div
          key={item.key}
          onClick={() => navigate(item.path)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: '4px 12px',
            minWidth: '60px',
            color: isActive(item.path) ? '#1890ff' : '#8c8c8c',
            transition: 'color 0.3s'
          }}
        >
          <div style={{ fontSize: '20px', marginBottom: '4px' }}>
            {item.icon}
          </div>
          <span style={{ fontSize: '11px', fontWeight: isActive(item.path) ? 600 : 400 }}>
            {item.label}
          </span>
        </div>
      ))}
    </div>
  )
}

export default MobileNavigation

